import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'parseString',
  standalone: true
})
export class ParseStringPipe implements PipeTransform {
  transform(value: string): string {
    if (value === 'AUTOBID') {
      return 'AutoBid';
    }
    return value
      .replace(/_/g, ' ')
      .toLowerCase()
      .replace(/(?:^|\s)\S/g, a => a.toUpperCase());
  }
}
